/*
* Broadcast Theme
*
* Custom Javascript for Zayla New York
* - No auto-selection of size on page load (metal defaults to 14K)
* - Auto-select first available size when color/metal changes
* - Disable Add to Cart until size is selected
* - Enhanced sold-out variant styling
*/

(function() {
  'use strict';

  /* ── Inject sold-out enhancement CSS ── */
  var style = document.createElement('style');
  style.textContent = [
    '/* Make sold-out/disabled variant buttons more visually obvious */',
    '.radio__fieldset .radio__button input.disabled + label {',
    '  opacity: 0.35;',
    '  text-decoration: line-through;',
    '}',
    '.radio__fieldset .radio__button input.disabled + label:hover {',
    '  opacity: 0.55;',
    '}',
    '/* "Select a size" prompt styling */',
    'button[data-add-to-cart][disabled] {',
    '  opacity: 0.6;',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  /* ── Helpers ── */
  function isSizeOption(name) {
    var n = name.toLowerCase();
    return n === 'size' || n === 'ring size';
  }

  function isMetalOption(name) {
    var n = name.toLowerCase();
    return n.indexOf('material') !== -1 ||
           n.indexOf('metal') !== -1 ||
           n.indexOf('jewelry material') !== -1 ||
           n.indexOf('color') !== -1;
  }

  function getRadioButtons(optionPosition) {
    var wrapper = document.querySelector('[data-option-position="' + optionPosition + '"]');
    if (!wrapper) return [];
    return Array.from(wrapper.querySelectorAll('input[type="radio"]'));
  }

  function getSelectedValue(radios) {
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) return radios[i].value;
    }
    return null;
  }

  function selectRadio(radios, value) {
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) {
        radios[i].checked = true;
        radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function uncheckAll(radios) {
    radios.forEach(function(r) { r.checked = false; });
  }

  function disableAddToCart() {
    var btn = document.querySelector('button[data-add-to-cart]');
    if (btn) {
      btn.setAttribute('disabled', 'disabled');
      var textEl = btn.querySelector('[data-add-to-cart-text]');
      if (textEl) {
        textEl.setAttribute('data-original-text', textEl.textContent.trim());
        textEl.textContent = 'Select a size';
      }
    }
  }

  function enableAddToCart() {
    var btn = document.querySelector('button[data-add-to-cart]');
    if (btn) {
      btn.removeAttribute('disabled');
      var textEl = btn.querySelector('[data-add-to-cart-text]');
      if (textEl) {
        var original = textEl.getAttribute('data-original-text');
        if (original) textEl.textContent = original;
      }
    }
  }

  /* ── Main init ── */
  function init() {
    // Only run on product pages
    var productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    var handle = productInfo.getAttribute('data-product-handle');
    if (!handle) return;

    // If URL already has a variant parameter, don't interfere
    if (window.location.search.indexOf('variant=') !== -1) return;

    // Fetch product data from Shopify AJAX API
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        applyVariantLogic(product);
      })
      .catch(function(err) {
        console.warn('Zayla custom.js: Could not load product data', err);
      });
  }

  function applyVariantLogic(product) {
    if (!product || !product.variants || product.variants.length <= 1) return;

    // Find size and metal option indices
    var sizeIdx = -1;
    var metalIdx = -1;

    for (var i = 0; i < product.options.length; i++) {
      if (isSizeOption(product.options[i])) sizeIdx = i;
      if (isMetalOption(product.options[i])) metalIdx = i;
    }

    var sizePosition = sizeIdx >= 0 ? sizeIdx + 1 : -1;
    var metalPosition = metalIdx >= 0 ? metalIdx + 1 : -1;

    // ── Step 1: Uncheck size radios (no auto-selection) ──
    if (sizePosition > 0) {
      var sizeRadios = getRadioButtons(sizePosition);
      uncheckAll(sizeRadios);

      // Clear the displayed value text
      var sizeWrapper = document.querySelector('[data-option-position="' + sizePosition + '"]');
      if (sizeWrapper) {
        var valueDisplay = sizeWrapper.querySelector('[data-selected-value]');
        if (valueDisplay) valueDisplay.textContent = '';
      }

      // Disable Add to Cart until size is selected
      disableAddToCart();

      // Listen for size selection to re-enable
      if (sizeWrapper) {
        sizeWrapper.addEventListener('change', function() {
          enableAddToCart();
        });
      }
    }

    // ── Step 2: Default metal to 14K if available ──
    if (metalPosition > 0) {
      var metalRadios = getRadioButtons(metalPosition);
      var currentMetal = getSelectedValue(metalRadios);

      if (currentMetal && currentMetal.toLowerCase().indexOf('14k') === -1) {
        // Try to find and select a 14K option
        for (var j = 0; j < metalRadios.length; j++) {
          if (metalRadios[j].value.toLowerCase().indexOf('14k') !== -1) {
            // Uncheck current, check 14K
            metalRadios.forEach(function(r) { r.checked = false; });
            metalRadios[j].checked = true;
            metalRadios[j].dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      }
    }

    // ── Step 3: When metal changes, auto-select first available size ──
    if (metalPosition > 0 && sizePosition > 0) {
      var metalWrapper = document.querySelector('[data-option-position="' + metalPosition + '"]');
      if (metalWrapper) {
        metalWrapper.addEventListener('change', function(e) {
          if (!e.target || e.target.type !== 'radio') return;

          var newMetal = e.target.value;
          var sizeRadiosNow = getRadioButtons(sizePosition);
          var currentSize = getSelectedValue(sizeRadiosNow);

          // If a size is selected, check if it's still available with new metal
          if (currentSize) {
            var isAvailable = product.variants.some(function(v) {
              return v.available &&
                     v.options[metalIdx] === newMetal &&
                     v.options[sizeIdx] === currentSize;
            });
            if (isAvailable) return; // Current size works with new metal
          }

          // Auto-select first available size for this metal
          var found = false;
          for (var k = 0; k < product.variants.length; k++) {
            var v = product.variants[k];
            if (v.available && v.options[metalIdx] === newMetal) {
              selectRadio(sizeRadiosNow, v.options[sizeIdx]);
              enableAddToCart();
              found = true;
              break;
            }
          }

          if (!found) {
            uncheckAll(sizeRadiosNow);
            disableAddToCart();
          }
        });
      }
    }
  }

  /* ── Bootstrap ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(init, 200);
    });
  } else {
    setTimeout(init, 200);
  }
})();

/*
 * Sync duplicate Price-{sectionId} blocks on variant change.
 * APO (Avis Product Options) clones .product__price__wrap into .apo-variant-price,
 * producing two elements with the same id. Broadcast's product-info JS uses
 * querySelector and only updates the first — leaving APO's clone with a stale
 * sale price (compare-at gets patched by APO separately, sale price doesn't).
 */
(function () {
  'use strict';
  if (typeof subscribe !== 'function') return;
  if (!window.theme || !window.theme.PUB_SUB_EVENTS || !window.theme.PUB_SUB_EVENTS.variantChange) return;

  subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (payload) {
    var data = payload && payload.data;
    if (!data || !data.html || !data.sectionId) return;
    var src = data.html.querySelector('#Price-' + data.sectionId);
    if (!src) return;
    var dupes = document.querySelectorAll('#Price-' + data.sectionId);
    if (dupes.length < 2) return;
    dupes.forEach(function (el) { el.innerHTML = src.innerHTML; });
  });
})();

/*
 * Variant-image gallery behavior.
 * Pairs with the "Hide variant images in gallery" setting in the Product pages
 * section (snippets/product.liquid): variant-assigned images carry a
 * .media--variant class and are hidden from the gallery flow.
 * - Desktop (stacked/mosaic/grid layouts): on variant change, the theme marks the
 *   variant's slide .media--active; we move that slide to the front of the media
 *   list so it shows as the main product image — replacing the old page-scroll.
 * - Fader galleries (mobile thumbs, desktop thumbnails): swiping/arrowing skips
 *   hidden variant slides so they don't repeat mid-gallery.
 */
(function () {
  'use strict';
  if (!window.customElements || !customElements.whenDefined) return;

  customElements.whenDefined('product-images').then(function () {
    var ProductImages = customElements.get('product-images');
    var proto = ProductImages && ProductImages.prototype;
    if (!proto || proto.__zaylaVariantMedia) return;
    proto.__zaylaVariantMedia = true;

    var origSetActiveMedia = proto.setActiveMedia;
    proto.setActiveMedia = function (id) {
      origSetActiveMedia.call(this, id);
      try {
        if (window.theme && window.theme.isMobile) return;
        if (this.hasAttribute('data-fader-desktop')) return;
        var slide = this.querySelector('[data-media-id="' + id + '"]');
        if (!slide || !slide.classList.contains('media--variant')) return;
        var list = slide.parentElement;
        if (list && list.firstElementChild !== slide) list.prepend(slide);
      } catch (e) {
        /* never break the gallery */
      }
    };

    function adjacentVisibleMediaId(el, dir) {
      var slides = Array.prototype.slice.call(el.querySelectorAll('[data-slide][data-media-id]'));
      if (!slides.length) return null;
      var active = el.querySelector('[data-slide].media--active') || slides[0];
      var idx = slides.indexOf(active);
      for (var step = 1; step <= slides.length; step++) {
        var pos = ((idx + dir * step) % slides.length + slides.length) % slides.length;
        var candidate = slides[pos];
        if (candidate === active) break;
        if (!candidate.classList.contains('media--variant')) {
          return candidate.getAttribute('data-media-id');
        }
      }
      return active.getAttribute('data-media-id');
    }

    var origNext = proto.getNextMediaId;
    var origPrev = proto.getPreviousMediaId;
    proto.getNextMediaId = function () {
      if (!this.querySelector('.media--variant')) return origNext.call(this);
      return adjacentVisibleMediaId(this, 1);
    };
    proto.getPreviousMediaId = function () {
      if (!this.querySelector('.media--variant')) return origPrev.call(this);
      return adjacentVisibleMediaId(this, -1);
    };
  });
})();

/*
 * Shop the Look — Zayla custom (2026-07-04)
 * Pairs with snippets/shop-the-look.liquid + the "Enable shop the look" setting
 * (Product pages section). Each tagged gallery photo renders a hidden .stl badge
 * that lists the OTHER products in that photo (from the shop_the_look metaobject).
 * This IIFE injects the badge/sheet CSS, excludes the product you're viewing and
 * counts what's left (revealing the badge only when >=1 remains), and wires the
 * tap-to-open/close behavior. Fails silent; never blocks the gallery or zoom.
 */
(function () {
  'use strict';

  var CSS = [
    '.product__photo{position:relative}',
    '.stl{position:absolute;left:10px;bottom:10px;z-index:3}',
    '.stl[hidden]{display:none}',
    '.stl__badge{display:inline-flex;align-items:center;gap:6px;border:0;cursor:pointer;background:#fff;color:#1a1a1a;font-size:12px;line-height:1;font-weight:500;padding:8px 12px;border-radius:999px;box-shadow:0 1px 6px rgba(0,0,0,.16);-webkit-appearance:none;appearance:none}',
    '.stl__badge:hover{background:#f6f5f2}',
    '.stl__tag{width:14px;height:14px;display:block;flex:0 0 auto}',
    '.stl__count{opacity:.55}',
    '.stl__count[hidden]{display:none}',
    '.stl__sheet{position:absolute;left:0;bottom:calc(100% + 8px);width:min(280px,78vw);background:#fff;border-radius:12px;box-shadow:0 6px 24px rgba(0,0,0,.18);padding:8px}',
    '.stl__sheet[hidden]{display:none}',
    '.stl__head{display:flex;align-items:center;justify-content:space-between;padding:4px 6px 8px;font-size:12px;font-weight:500;color:#6b6b6b;letter-spacing:.02em}',
    '.stl__close{border:0;background:transparent;cursor:pointer;color:#6b6b6b;padding:2px;display:inline-flex;line-height:0}',
    '.stl__close svg{width:16px;height:16px}',
    '.stl__list{list-style:none;margin:0;padding:0}',
    '.stl__item{margin:0}',
    '.stl__item[hidden]{display:none}',
    '.stl__link{display:flex;align-items:center;gap:10px;padding:6px;border-radius:8px;text-decoration:none;color:#1a1a1a}',
    '.stl__link:hover{background:#f6f5f2}',
    '.stl__thumb{flex:0 0 auto;width:44px;height:44px;border-radius:6px;overflow:hidden;background:#f1efe8}',
    '.stl__img{width:100%;height:100%;object-fit:cover;display:block}',
    '.stl__info{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:2px}',
    '.stl__title{font-size:13px;font-weight:500;line-height:1.25;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
    '.stl__price{font-size:12px;color:#6b6b6b}',
    '.stl__go{flex:0 0 auto;width:16px;height:16px;color:#b0aca0}',
    '.stl__item--current .stl__go{display:none}',
    '.stl__item--current .stl__link{cursor:default}',
    '.stl__item--current .stl__link:hover{background:transparent}',
    '.stl__item--current .stl__title{white-space:normal;overflow:visible}',
    '.stl__current-tag{color:#a29e94;font-weight:400;font-size:11px}'
  ].join('');

  function injectCSS() {
    if (document.getElementById('stl-styles')) return;
    var s = document.createElement('style');
    s.id = 'stl-styles';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function currentProductId(el) {
    var host = el.closest ? el.closest('product-info') : null;
    return host ? (host.getAttribute('data-product-id') || '') : '';
  }

  function currentProductHandle(el) {
    var host = el.closest ? el.closest('product-info') : null;
    return host ? (host.getAttribute('data-product-handle') || '') : '';
  }

  function handleFromHref(href) {
    var m = (href || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  /* GA4 events ride the Google channel's page-level gtag (same client + session
     as pageviews/purchases). dataLayer is the GTM fallback; Shopify.analytics
     feeds any future web pixels. Analytics must never break the gallery. */
  function stlTrack(name, params) {
    try {
      var p = {};
      for (var k in params) { if (params[k] !== '' && params[k] != null) p[k] = params[k]; }
      if (typeof window.gtag === 'function') {
        p.transport_type = 'beacon';
        window.gtag('event', name, p);
      } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        var d = { event: name };
        for (var k2 in p) { d[k2] = p[k2]; }
        window.dataLayer.push(d);
      }
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, p);
      }
    } catch (e) { /* never break the gallery */ }
  }

  /* GA4 standard ecommerce funnel: view_item_list when the sheet opens,
     select_item on click-through. The item shape mirrors Shopify's own
     view_item exactly — id "shopify_US_<productId>_<variantId>" plus
     name/brand/category/price/variant — so these rows join the SAME catalog
     items as the store's view_item/add_to_cart/purchase events in GA4 (that's
     what makes list attribution work). Sent only to the GA4 property so the
     Google Ads / Merchant Center destinations stay untouched. */
  var STL_GA4_ID = 'G-VFHNVHMEQ6';
  function stlGaItem(li) {
    var item = {
      id: 'shopify_US_' + (li.getAttribute('data-stl-pid') || '') + '_' + (li.getAttribute('data-stl-vid') || ''),
      name: li.getAttribute('data-stl-name') || '',
      brand: li.getAttribute('data-stl-brand') || 'Zayla',
      category: li.getAttribute('data-stl-cat') || '',
      variant: li.getAttribute('data-stl-vtitle') || ''
    };
    var cents = parseInt(li.getAttribute('data-stl-price') || '0', 10);
    if (cents) item.price = Math.round(cents) / 100;
    return item;
  }
  function stlGaEcommerce(eventName, items) {
    try {
      if (typeof window.gtag !== 'function' || !items || !items.length) return;
      window.gtag('event', eventName, {
        send_to: STL_GA4_ID,
        item_list_id: 'shop_the_look',
        item_list_name: 'Shop the Look',
        items: items
      });
    } catch (e) { /* never break the gallery */ }
  }

  function closeAll(except) {
    var sheets = document.querySelectorAll('[data-stl] [data-stl-sheet]');
    Array.prototype.forEach.call(sheets, function (sheet) {
      if (sheet === except || sheet.hidden) return;
      sheet.hidden = true;
      var wrap = sheet.closest('[data-stl]');
      var t = wrap && wrap.querySelector('[data-stl-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  function toggleSheet(stl) {
    var sheet = stl.querySelector('[data-stl-sheet]');
    var toggle = stl.querySelector('[data-stl-toggle]');
    if (!sheet) return;
    var willOpen = sheet.hidden;
    closeAll(willOpen ? sheet : null);
    sheet.hidden = !willOpen;
    if (toggle) toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (willOpen) {
      stlTrack('this_look_open', {
        photo: stl.getAttribute('data-stl-file'),
        product: currentProductHandle(stl)
      });
      var stlVis = stl.querySelectorAll('[data-stl-item]:not([hidden]):not(.stl__item--current)');
      stlGaEcommerce('view_item_list', Array.prototype.map.call(stlVis, stlGaItem));
    }
  }

  function initOne(stl) {
    if (stl.__stlReady) return;
    stl.__stlReady = true;

    var pid = currentProductId(stl);
    var items = stl.querySelectorAll('[data-stl-item]');
    var total = 0;   // available pieces shown in this look
    var others = 0;  // available pieces other than the one you're viewing
    Array.prototype.forEach.call(items, function (li) {
      if (li.hasAttribute('data-stl-soldout')) return; // sold out -> already dropped server-side
      total++;
      if (pid && li.getAttribute('data-stl-pid') === pid) {
        // The product you're on stays in the list, tagged, but doesn't link to itself.
        li.classList.add('stl__item--current');
        var titleEl = li.querySelector('.stl__title');
        if (titleEl && !li.__stlMarked) {
          li.__stlMarked = true;
          var tag = document.createElement('span');
          tag.className = 'stl__current-tag';
          tag.textContent = ' (this product)';
          titleEl.appendChild(tag);
        }
      } else {
        others++;
      }
    });

    // Only badge a photo that has at least one OTHER product to shop.
    if (others < 1) { stl.hidden = true; return; }

    var countEl = stl.querySelector('[data-stl-count]');
    if (countEl && total > 1) {
      countEl.textContent = '· ' + total;
      countEl.hidden = false;
    }
    stl.hidden = false;
    stlTrack('this_look_view', {
      photo: stl.getAttribute('data-stl-file'),
      product: currentProductHandle(stl),
      items: total
    });

    stl.addEventListener('click', function (e) {
      // Keep every badge/sheet click from reaching the photo's zoom/lightbox handler.
      e.stopPropagation();
      if (e.target.closest('[data-stl-toggle]')) { e.preventDefault(); toggleSheet(stl); return; }
      if (e.target.closest('[data-stl-close]')) { e.preventDefault(); closeAll(null); return; }
      if (e.target.closest('.stl__item--current')) { e.preventDefault(); return; } // you're already here
      var stlLink = e.target.closest('.stl__link');
      if (stlLink) {
        stlTrack('this_look_click', {
          photo: stl.getAttribute('data-stl-file'),
          product: currentProductHandle(stl),
          to_product: handleFromHref(stlLink.getAttribute('href'))
        });
        var stlClickedLi = stlLink.closest('[data-stl-item]');
        if (stlClickedLi) stlGaEcommerce('select_item', [stlGaItem(stlClickedLi)]);
      }
      // Product links then fall through and navigate.
    });
  }

  function init() {
    injectCSS();
    var nodes = document.querySelectorAll('[data-stl]');
    Array.prototype.forEach.call(nodes, initOne);
  }

  document.addEventListener('click', function () { closeAll(null); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Broadcast swaps gallery slides on variant change; re-scan any new badges.
  if (typeof subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS && window.theme.PUB_SUB_EVENTS.variantChange) {
    subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function () { setTimeout(init, 50); });
  }
})();
